export const getGender = (formatMessage) => {
  return [
    { label: formatMessage({ id: 'text.male' }), value: 'male' },
    { label: formatMessage({ id: 'text.female' }), value: 'female' },
    { label: formatMessage({ id: 'label.others' }), value: 'others' },
  ]
}
